import { Section, SectionHead } from "./SectionPrimitives";

export default function KeywordsSection({ kwBreakdown, missedPct }) {
  if (!kwBreakdown?.rows?.length) return null;

  return (
    <Section id="keywords">
      <SectionHead num="03" title="Keyword Visibility Matrix" subtitle={`${kwBreakdown.total_searches?.toLocaleString()} people search these terms every month. Here's your visibility for each.`} />
      <div className="report-scroll-table">
        <table style={{ borderCollapse: "collapse", fontSize: 13 }}>
          <thead><tr style={{ background: "#F8FAFC" }}>
            <th style={{ padding: "12px 14px", textAlign: "left", fontWeight: 700, color: "#475569", fontSize: 12, borderBottom: "2px solid #E2E8F0", fontFamily: "'IBM Plex Sans',sans-serif", whiteSpace: "nowrap" }}>Keyword</th>
            <th style={{ padding: "12px 14px", textAlign: "center", fontWeight: 700, color: "#475569", fontSize: 12, borderBottom: "2px solid #E2E8F0", fontFamily: "'IBM Plex Sans',sans-serif", whiteSpace: "nowrap" }}>Volume</th>
            <th style={{ padding: "12px 14px", textAlign: "center", fontWeight: 700, color: "#475569", fontSize: 12, borderBottom: "2px solid #E2E8F0", fontFamily: "'IBM Plex Sans',sans-serif", whiteSpace: "nowrap" }}>Your Visibility</th>
            <th style={{ padding: "12px 14px", textAlign: "center", fontWeight: 700, color: "#475569", fontSize: 12, borderBottom: "2px solid #E2E8F0", fontFamily: "'IBM Plex Sans',sans-serif", whiteSpace: "nowrap" }}>Opportunity</th>
          </tr></thead>
          <tbody>
            {kwBreakdown.rows.map((row, i) => {
              const visPct = Math.max(5, 100 - (missedPct + i * 8));
              const oppLevel = visPct < 30 ? "High" : visPct < 60 ? "Medium" : "Low";
              const oppColor = visPct < 30 ? "#E11D48" : visPct < 60 ? "#D97706" : "#059669";
              const oppBg = visPct < 30 ? "#FEF2F2" : visPct < 60 ? "#FFFBEB" : "#ECFDF5";
              return (
                <tr key={i} className="tbl-row" style={{ borderBottom: "1px solid #F1F5F9" }}>
                  <td style={{ padding: "12px 14px", fontWeight: 600, color: "#1E293B", fontFamily: "'IBM Plex Sans',sans-serif", maxWidth: 160 }}>{row.keyword}</td>
                  <td style={{ padding: "12px 14px", textAlign: "center", color: "#475569", fontWeight: 600, fontFamily: "'JetBrains Mono',monospace", whiteSpace: "nowrap" }}>{row.monthly_searches?.toLocaleString()}</td>
                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center" }}>
                      <div style={{ width: 50, height: 6, background: "#F1F5F9", overflow: "hidden" }}>
                        <div style={{ height: "100%", width: `${visPct}%`, background: visPct < 30 ? "#E11D48" : visPct < 60 ? "#D97706" : "#059669" }} />
                      </div>
                      <span style={{ fontSize: 12, fontWeight: 700, color: "#475569", fontFamily: "'JetBrains Mono',monospace", whiteSpace: "nowrap" }}>{visPct}%</span>
                    </div>
                  </td>
                  <td style={{ padding: "12px 14px", textAlign: "center" }}>
                    <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", background: oppBg, color: oppColor, whiteSpace: "nowrap", border: `1px solid ${oppColor}22` }}>{oppLevel}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Section>
  );
}
